import * as Yup from 'yup';

export default Yup.object().shape({
  marketing_personal_data_consent: Yup.boolean(),
});
